<p-dialog [style]="{ width: '440px' }" [breakpoints]="{ '575px': '92vw' }" [(visible)]="visibility"
    [modal]="true" [draggable]="false" [dismissableMask]="true" [closable]="false"
    [styleClass]="isApprove ? 'approve-photos-dialog' : 'reject-photos-dialog'">

    <ng-template #header>
        <div [class]="p + '-header'">
            <div [class]="p + '-header-icon'">
                <i class="fa-solid" [class.fa-check]="isApprove" [class.fa-xmark]="!isApprove"></i>
            </div>
            <div [class]="p + '-header-text'">
                <span [class]="p + '-title'">{{ isApprove ? 'Approve' : 'Reject' }} Operation Photos</span>
                <span [class]="p + '-subtitle'">Submission #{{ submission.id }} · {{ submission.plateNo }}</span>
            </div>
            <button type="button" [class]="p + '-close'" (click)="cancel()">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
    </ng-template>

    <div [class]="p + '-body'">
        <p [class]="p + '-description'">
            Are you sure you want to {{ isApprove ? 'approve' : 'reject' }} these operation photos?
        </p>
        <div [class]="p + '-field'">
            <label [class]="p + '-label'" for="operation-review-comment">
                {{ isApprove ? 'Comment' : 'Reason' }} <span [class]="p + '-optional'">(optional, max 500 chars)</span>
            </label>
            <textarea id="operation-review-comment" [(ngModel)]="comment" [maxlength]="500"
                [placeholder]="isApprove ? 'Add a comment...' : 'Enter reason...'"
                rows="4" [class]="p + '-textarea'"></textarea>
        </div>
    </div>

    <ng-template #footer>
        <div [class]="p + '-footer'">
            <button type="button" [class]="p + '-btn ' + p + '-btn--cancel'" [disabled]="loading" (click)="cancel()">
                Cancel
            </button>
            <button type="button" [class]="p + '-btn ' + p + '-btn--' + action" [disabled]="loading" (click)="submit()">
                @if (loading) {
                <i class="fa-solid fa-spinner fa-spin"></i> {{ isApprove ? 'Approving...' : 'Rejecting...' }}
                } @else {
                <i class="fa-solid" [class.fa-check]="isApprove" [class.fa-xmark]="!isApprove"></i> Sure
                }
            </button>
        </div>
    </ng-template>
</p-dialog>
